<script setup lang="ts">
import { PermissionResource } from '@swipe4work/models-orval'
import MatchList from './components/MatchList.vue'

import { useTopbarStore } from '@/components/app/topbar-store'

definePage({
  meta: {
    permissionResource: PermissionResource.Match,
  },
})

const topbarStore = useTopbarStore()
const { t } = useI18n()

topbarStore.setAndClear({
  breadcrumbs: [ { label: t('routes.matches') } ],
})
</script>

<template>
  <loading-wrapper>
    <MatchList />
  </loading-wrapper>
</template>
